import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GiftcardsAddedGiftcardComponentDef } from '@df/module-giftcards/giftcards-added-giftcard.component.def';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ActionComponent } from '../../ui/api/action.component';

@Component({
    selector: 'giftcards-added-giftcard',
    templateUrl: './giftcards-added-giftcard.html',
    standalone: true,
    imports: [ActionComponent, CommonModule, PriceComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GiftcardsAddedGiftcardComponent extends GiftcardsAddedGiftcardComponentDef {
    get lastFour(): string {
        const code = this.giftcard?.code;
        if (code) {
            return '...' + code.substr(code.length - 4);
        }
        return '';
    }

    get value(): number {
        return this.giftcard?.amount;
    }
}
